export const SOLUTIONS = {
    0: {
      answer: ["cheater", "imposter", "hacker", "trickster"],
      hint: "Someone who looks at the solution source code instead of playing the game...",
    },
    1: {
      answer: ["rose", "tulip", "daisy", "sunflower"],
      hint: "Garden fare or wandering trader from Stardew Valley.",
    },
    2: {
      answer: ["hermione", "ronald", "fred", "minerva"],
      hint: "Your a wizard Harry!",
    },
    3: {
      answer: ["rust", "python", "javascript", "assembly"],
      hint: "Languages that power the digital world.",
    },
    4: {
      answer: ["dolphin", "whale", "shark", "octopus"],
      hint: "They spend a lot of time exploring the ocean!",
    },
    5: {
      answer: ["cookie", "lizard", "catnip", "turkey"],
      hint: "The Cookie Monster loves... but also loves...",
    },
    6: {
      answer: ["mountain", "valley", "plateau", "canyon"],
      hint: "Explore Earth's varied terrain from peaks to troughs.",
    },
    7: {
      answer: ["comedy", "drama", "thriller", "romance"],
      hint: "Genres that play out life's script on the big screen.",
    },
    8: {
      answer: ["hydrogen", "carbon", "calcium", "oxygen"],
      hint: "Theyre elemental-ly found in the body…",
    },
    9: {
      answer: ["novel", "poetry", "drama", "mystery"],
      hint: "Literary forms that unfold stories.",
    },
    10: {
      answer: ["rain", "snow", "sunshine", "breeze"],
      hint: "Experience nature's weather report with these elements.",
    },
    11: {
      answer: ["camera", "brush", "pen", "chisel"],
      hint: "Tools that paint the canvas of creativity.",
    },
    12: {
      answer: ["mergesort", "algorithm", "pointers", "shell"],
      hint: "Some of the greatest computer scientist can master these.",
    },
    13: {
      answer: ["science", "history", "math", "language"],
      hint: "Unlock the 'knowledge' vault with these subjects.",
    },
    14: {
      answer: ["laughter", "joy", "surprise", "contentment"],
      hint: "Feelings that add 'color' to the canvas of human experience.",
    },
    15: {
      answer: ["moon", "stars", "galaxy", "cosmos"],
      hint: "Explore the celestial 'dance' in the night sky.",
    },
    16: {
      answer: ["chef", "scientist", "artist", "athlete"],
      hint: "People whose professions showcase diverse 'skills'.",
    },
    17: {
      answer: ["island", "peninsula", "archipelago", "cape"],
      hint: "Geographical features that 'shape' landscapes.",
    },
    18: {
      answer: ["heartbreak", "alone", "betrayal", "forsaken"],
      hint: "Forever broken he walk's a life of solitude",
    },
    19: {
      answer: ["computer", "tablet", "smartphone", "laptop"],
      hint: "Digital 'companions' in the modern age.",
    },
    20: {
      answer: ["athlete", "musician", "scientist", "artist"],
      hint: "People who excel in their fields, true 'talent' ambassadors.",
    },
  };